import { initContract } from '@ts-rest/core';
import { adminContract } from './contracts/admin';
import { ag5Contract } from './contracts/ag5';
import { authContract } from './contracts/auth';
import { brainContract } from './contracts/brain';
import { caloriesContract } from './contracts/calories';
import { checklistsContract } from './contracts/checklists';
import { financesContract } from './contracts/finances';
import { recipesContract } from './contracts/recipes';

const c = initContract();

/**
 * The whole HTTP surface. Everything sits under `/api` so the SPA fallback can
 * take every other path without ambiguity.
 */
export const contract = c.router(
  {
    auth: authContract,
    admin: adminContract,
    ag5: ag5Contract,
    finances: financesContract,
    brain: brainContract,
    calories: caloriesContract,
    recipes: recipesContract,
    checklists: checklistsContract,
  },
  { pathPrefix: '/api' },
);

export type Contract = typeof contract;

export * from './common';
export * from './entities';
export * from './format';
export * from './inputs';

// Star-exported so a route's body schema and its parsed type travel with the
// contract that defines them — a service importing `WalletBody` is reading the
// same declaration the endpoint validates against.
export * from './contracts/admin';
export * from './contracts/ag5';
export * from './contracts/auth';
export * from './contracts/brain';
export * from './contracts/calories';
export * from './contracts/checklists';
export * from './contracts/finances';
export * from './contracts/recipes';
